import {
  ASSISTANT_API_KEY_ENV_MAP,
  ASSISTANT_API_URL_MAP,
  CurrentEnvironment,
  ENV_ADMIN_MAP,
  NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP,
  NOVE8_SUBSCRIPTIONS_ENV_MAP,
} from 'root-constants'
import { ApiService } from 'services/api.service'
import { AdminApi } from './AdminApi'
import { AssistantApi } from './AssistantApi'
import { CalendlyApi } from './CalendlyApi'
import { GoogleSheetsApi } from './GoogleSheetsApi'
import { SubscriptionsApi } from './SubscriptionsApi'
import { AutomationApi } from './AutomationApi'
import { GeoApi } from './GeoApi'
import { BreedIdApi } from './BreedIdApi'

const CALENDLY_TOKEN =
  'eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzMxNTAzNDU0LCJqdGkiOiJhY2FmMWM5Zi01ODJjLTQ2OTUtODVjMC0zMjFhZTFjZDg1MjEiLCJ1c2VyX3V1aWQiOiI1ZWU4Y2MyNi1jMmE1LTQzZjEtODQ0ZS0zNjYxNzc2MmIyNGQifQ.o2Wr0MwhevRTUpjdA8We8osAln-YuZaiFiahg9DQPuX-ZTJNRikSBCPTg7rsyrOv36uQIrtjBUXGmuNWJk_Y4Q'

const assistantApiService = new ApiService(
  `https://${
    ASSISTANT_API_URL_MAP[import.meta.env.CURRENT_ENV] ||
    ASSISTANT_API_URL_MAP[CurrentEnvironment.DEV]
  }`,
  new Headers({
    'x-api-key':
      ASSISTANT_API_KEY_ENV_MAP[import.meta.env.CURRENT_ENV] ||
      ASSISTANT_API_KEY_ENV_MAP.dev,
  }),
)
const subscriptionsApiService = new ApiService(
  `https://${
    NOVE8_SUBSCRIPTIONS_ENV_MAP[import.meta.env.CURRENT_ENV] ||
    NOVE8_SUBSCRIPTIONS_ENV_MAP[CurrentEnvironment.DEV]
  }`,
  new Headers({
    'x-api-key':
      NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP[import.meta.env.CURRENT_ENV] ||
      NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP[CurrentEnvironment.DEV],
  }),
)
const adminApiService = new ApiService(
  `https://${
    ENV_ADMIN_MAP[import.meta.env.CURRENT_ENV] ||
    ENV_ADMIN_MAP[CurrentEnvironment.DEV]
  }`,
)
const calendlyApiService = new ApiService(
  '',
  new Headers({
    Authorization: `Bearer ${CALENDLY_TOKEN}`,
  }),
)
const googleSheetsApiService = new ApiService('')
const geoApiService = new ApiService('')
const automationApiService = new ApiService('')
const nove8BaseService = new ApiService('')

export const assistantApi = new AssistantApi(assistantApiService)
export const subscriptionsApi = new SubscriptionsApi(subscriptionsApiService)
export const adminApi = new AdminApi(adminApiService)
export const calendlyApi = new CalendlyApi(calendlyApiService)
export const googleSheetsApi = new GoogleSheetsApi(googleSheetsApiService)
export const geoApi = new GeoApi(geoApiService)
export const automationApi = new AutomationApi(automationApiService)
export const breedIdApi = new BreedIdApi(nove8BaseService)
